<div class="p-4 bg-white">
  <img
			src="assets/svg/x.svg"
			alt=""
			class="close-button"
			(click)="close()"
            width="14px"
            height="14px"
		/>
    <div class="row">
      <div class="d-flex">
        <img src="../../../../assets/svg/dollar.svg" alt="" />
        <h1 class="my-auto ms-2">Detalle de nota de crédito</h1>
      </div>
      <div class="mt-4">
        <p class="label-title">ID</p>
        <p class="label-information">#64759303</p>
        <hr>
        <p class="label-title">Empresa contratista</p>
        <p class="label-information">Asignado a VETA SERIGRAFIA SPA</p>
        <hr>
        <p class="label-title">CUIT</p>
        <p class="label-information">111111-1</p>
        <hr>
        <p class="label-title">Servicio Brindado</p>
        <p class="label-information">14 de Septiembre a las 13:45 Hrs.</p>
        <hr>
        <p class="label-title">Fecha y hora nota de crédito</p>
        <p class="label-information">14 de Septiembre a las 13:45 Hrs.</p>
        <hr>
        <p class="label-title">Usuario efector</p>
        <p class="label-information">Yerko Flores</p>
        <hr>

        
          <span class="label-title">Sub total: </span>
          <span class="float-end label-amount">$1.740.567</span>
          <br>
          <br>
          <span class="label-title">IVA: </span>
          <span class="float-end label-amount">$450.000 </span>
          <br>
          <br>
          <span class="label-title">TOTAL</span>
          <span class="float-end label-amount blue">1.740</span>
          <hr>
        

        <div class="col-md-4 float-end">
        <button class="btn btn-dark btn-block " >
          Descargar detalle
        </button>
        </div>
      </div>
    </div>
  </div>
  